import { useEffect, useState } from 'react';
import type { DateKey } from '@/domain/date';
import { windowFor } from '@/domain/report';
import type { DayRecord } from '@/domain/streaks';
import { useAppState } from './useAppState';

/** The seven days ending on `anchor`, loaded in one round trip. */
export function useWindowRecords(anchor: DateKey) {
  const { backend } = useAppState();
  const [days, setDays] = useState<DayRecord[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    const { from, to } = windowFor(anchor);
    void (async () => {
      const loaded = await backend.records.range(from, to);
      if (cancelled) return;
      setDays(loaded);
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, [backend, anchor]);

  return { days, loading };
}
